import React from 'react'
import axios from 'axios'
import { Typography, TextField, Button, IconButton } from '@material-ui/core'
import { Delete as DeleteIcon } from '@material-ui/icons'

const AssumptionsList = ({ areaId, assumptions, url, onUpdated }) => {
  const [input, setInput] = React.useState('')

  const handleAdd = () => {
    if (!input.trim()) return
    axios.post(`${url}/api/bid-estimation/areas/${areaId}/assumptions`, { text: input.trim() })
      .then(res => {
        onUpdated(res.data)
        setInput('')
      })
      .catch(err => console.error('Failed to add assumption:', err))
  }

  const handleDelete = (assumptionId) => {
    axios.delete(`${url}/api/bid-estimation/areas/${areaId}/assumptions/${assumptionId}`)
      .then(res => onUpdated(res.data))
      .catch(err => console.error('Failed to delete assumption:', err))
  }

  return (
    <div style={{ marginBottom: 16 }}>
      <Typography variant="subtitle2" style={{ fontWeight: 600, fontSize: 13, marginBottom: 4 }}>Assumptions</Typography>
      {(assumptions || []).map(a => (
        <div key={a._id} style={{ display: 'flex', alignItems: 'center', gap: 4, padding: '4px 0', borderBottom: '1px solid #f0f0f0' }}>
          <Typography variant="body2" style={{ flex: 1, fontSize: 13 }}>{a.text}</Typography>
          <IconButton size="small" onClick={() => handleDelete(a._id)}>
            <DeleteIcon fontSize="small" />
          </IconButton>
        </div>
      ))}
      <div style={{ display: 'flex', gap: 4, marginTop: 8 }}>
        <TextField
          size="small"
          variant="outlined"
          placeholder="Add assumption..."
          value={input}
          onChange={e => setInput(e.target.value)}
          onKeyDown={e => e.key === 'Enter' && (e.preventDefault(), handleAdd())}
          style={{ flex: 1 }}
          inputProps={{ style: { fontSize: 12, padding: '6px 8px' } }}
        />
        <Button size="small" onClick={handleAdd} disabled={!input.trim()} variant="outlined" style={{ textTransform: 'none', fontSize: 11 }}>
          Add
        </Button>
      </div>
    </div>
  )
}

export default AssumptionsList
